module.exports = __webpack_public_path__ + "static/media/brain.6afe8ffa.png";